import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';
import HomeSolutions from '../components/HomeSolutions';
import Widgets from '../components/WidgetTiles';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Home | Redemption Psychiatry</title>
            </Helmet>

            <Header />

            <div id="content" role="main" className="home">

                {/* Hero Section */}
                <Hero />

                {/* Home Introduction Section */}
                <div id="home-introduction-container" className="container">
                    <h2>Mental Healthcare Designed for You</h2>
                    <p className="large">
                        Redemption Psychiatry was founded on a single principle: <strong><em>patients deserve better</em></strong>.<br />
                        Too often, mental healthcare feels impersonal, rushed, or ineffective. We set out to change that.
                    </p>
                </div>

                {/* Home Content Section */}
                <div id="home-content-container" className="container">
                    <div>
                        <div>
                            <LazyLoadImage alt="Secondary" effect="blur" src="/img/secondary-image.png" />
                        </div>
                        <div>
                            <p>
                                As a physician-owned practice, we believe in listening first, understanding your unique challenges,
                                and crafting solutions that work for you. By integrating <strong>cutting-edge science with compassionate care</strong>,
                                we help our patients regain hope, stability, and control over their lives.
                            </p>
                            <p className="title">Why Patients Trust Us:</p>
                            <ul>
                                <li>Physician-led, patient-first care</li>
                                <li>The latest breakthroughs in mental health treatments</li>
                                <li>In-person and virtual options for your convenience</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Testimonials Section */}
                <Testimonials />

                {/* Home Solutions Section */}
                <HomeSolutions />

                {/* CTA Knowledge Hub Section */}
                <div id="home-call-to-action-container" className="container-fluid lazy" style={{ backgroundImage: `url('/img/cta-background.png')` }}>
                    <div className="container">
                        <div>
                            <div></div> {/* Empty left column */}
                            <div>
                                <h2>Your Questions, Answered</h2>
                                <p className="large">
                                    Empower yourself with expert insights, research-backed articles, and real-life success stories.
                                </p>
                                <a href="/resources" className="button white">
                                    Explore
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Widgets Tiles Section */}
                <Widgets />

            </div> {/* END of #content */}
            <div className="push"></div>
            <Footer />
        </>
    );
};

export default Home;